const $outboundLinks = $('a[href^="http"]');

$outboundLinks.on('click', function(event){
    if (typeof ga !== "function") {
        return;
    }

    // event.preventDefault();

    let url = $(this).attr('href');

    ga('send', 'event', 'outbound', 'click', url, {
        'transport': 'beacon',
        'hitCallback': function(){
            console.log('ga.hitCallback for '+ url);
            document.location = url;
        }
    });
});

